import axios from 'axios';
import {Constants} from '../data/Constants'

export const ERROR_CODES_START = 400;

const Skye = window.Skye;
const BACKEND_URL = window._env_.BACKEND_URL;

export const getHttpClient = () => {
    const apiHttpClient = axios.create();

    apiHttpClient.interceptors.request.use(request => {
        return request;
    });

    apiHttpClient.interceptors.response.use(response => {
        console.log('Passing through interceptor');
        if (response.status === 200 && response.headers && response.headers.redirecturl) {
            console.log('Redirection request received: ', response.headers.redirecturl);
            window.location.href = response.headers.redirecturl;
        }
        return response;
    }, error => {
        if (error.response && error.response.status >= ERROR_CODES_START) {
            if (error.response.status === 401) {
                console.log('User not authorised. Please contact with the system administrator.');
                // window.location.reload();
            }

            return error.response;
        }
    });

    return apiHttpClient;
};

const HelperServices = {
    getJWTToken(username, password) {
        return new Promise(
            function (resolve, reject) {
                let data = {}
                data['username'] = username;
                data['password'] = password;
                Skye.HttpClient.post(BACKEND_URL + Constants.authenticateUser, data)
                    .then((response) => {
                        let token = 'Bearer '.concat(response.data.token);
                        localStorage.setItem('token', token);
                        resolve(response.status)
                    })
                    .catch((e) => {
                        try {
                            reject(e.response.status)
                        } catch (error) {
                        }

                    });
            });
    },
    async getTokenValidityStatus() {
        try {
            const res = await Skye.HttpClient.get(BACKEND_URL + Constants.getTokenValidityStatus, {
                headers: {
                    Authorization: localStorage.getItem('token')
                }
            })
            return await res.data;

        } catch (error) {
            return await false;
        }
    },
    getTemplates() {
        return new Promise(
            function (resolve, reject) {
                Skye.HttpClient.get(BACKEND_URL + Constants.getTemplates,
                    {
                        headers: {
                            Authorization: localStorage.getItem('token')
                        }
                    }
                )
                    .then((response) => {
                        if (response.data.status === Constants.Successful) {
                            resolve(JSON.parse(response.data.data))
                        } else if(response.data.status === 401){
                            reject(response.data);
                        }
                    })
                    .catch((e) => {
                        reject(e.response)
                    })
            });
    },
    getTemplateImages(templateId, type) {
        return new Promise(
            function (resolve, reject) {

                Skye.HttpClient.get(BACKEND_URL + Constants.getTemplateImage + templateId + type,
                    {
                        headers: {
                            Authorization: localStorage.getItem('token')
                        }
                    })
                    .then((response) => {
                        if (response.data.status === Constants.Successful) {
                            resolve(response.data.data);
                        } else {
                            reject('error')
                        }
                    })
                    .catch((e) => {
                        reject(e.response)
                    })
            });
    },
    getTemplateTaggingData(templateId) {
        return new Promise(
            function (resolve, reject) {
                Skye.HttpClient.get(BACKEND_URL + Constants.getTaggingData + templateId,
                    {
                        headers: {
                            Authorization: localStorage.getItem('token')
                        }
                    })
                    .then((response) => {
                        if (response.data.status === Constants.Successful) {
                            resolve(JSON.parse(response.data.data));
                        } else {
                            reject('error')
                        }

                    })
                    .catch((e) => {
                        reject(e.response)
                    })
            }
        )
    },
    uploadTemplate(data) {
        return new Promise(
            function (resolve, reject) {
                Skye.HttpClient.put(BACKEND_URL + Constants.uploadTemplate, data,
                    {
                        headers: {
                            Authorization: localStorage.getItem('token')
                        }
                    })
                    .then(response => {
                        if (response.data.status === Constants.Successful) {
                            resolve(response);
                        } else if (response.data.status === Constants.Failed) {
                            reject(response.data.errorMessage)
                        } else {
                            reject('error')
                        }
                    })
                    .catch((e) => {
                        reject(e.response)
                    })
            })
    },
    deleteTemplate(selectedItems) {
        return new Promise(
            function (resolve, reject) {
                Skye.HttpClient.put(BACKEND_URL + Constants.deleteTemplate, {'templateIdList': selectedItems},
                    {
                        headers: {
                            Authorization: localStorage.getItem('token')
                        }
                    })
                    .then(response => {
                        if (response.data.status === Constants.Successful) {
                            resolve(response.data.data);
                        } else {
                            reject('error')
                        }
                    })
                    .catch((e) => {
                        reject(e.response)
                    })
            })
    },

    sendDataToServer(data) {
        return new Promise(
            function (resolve, reject) {
                Skye.HttpClient.post(BACKEND_URL + Constants.submitDataApi, JSON.stringify(data), {
                    headers: {
                        'Content-type': Constants.ContentType,
                        Authorization: localStorage.getItem('token')
                    }
                })
                    .then(response => {
                        if (response.data.status === Constants.Successful) {
                            resolve(response);
                        } else if (response.data.status === Constants.Failed) {
                            reject(response.data.errorMessage)
                        } else {
                            reject('error')
                        }
                    })
                    .catch(error => {
                        reject(error.response)
                    })
            })

    },

    checkTemplateExistOrNot(data) {
        return new Promise(
            function (resolve, reject) {
                Skye.HttpClient.post(BACKEND_URL + Constants.validateTemplateIdUrl, JSON.stringify(data), {
                    headers: {
                        'Content-type': Constants.ContentType,
                        Authorization: localStorage.getItem('token')
                    }
                })
                    .then(response => {
                        if (response.data.status === Constants.Successful) {
                            resolve(response);
                        } else if (response.data.status === Constants.Failed) {
                            reject(response.data.errorMessage)
                        } else {
                            reject('error')
                        }
                    })
                    .catch(error => {
                        reject(error.response)
                    })
            })
    },

    uploadImage(data) {
        return new Promise(
            function (resolve, reject) {
                Skye.HttpClient.post(BACKEND_URL + Constants.uploadImageApi, data,
                    {
                        headers: {
                            Authorization: localStorage.getItem('token')
                        }
                    })
                    .then(response => {
                        if (response.data.status === Constants.Successful) {
                            resolve(response)
                        } else {
                            reject('error')
                        }
                    })
                    .catch((e) => {
                        reject(e.response)
                    })
            })
    },
    cropImage(data) {
        return new Promise(
            function (resolve, reject) {
                Skye.HttpClient.post(BACKEND_URL + Constants.cropImageApi, data, {
                    headers: {
                        Authorization: localStorage.getItem('token')
                    }
                })
                    .then(response => {
                        if (response.data.status === Constants.Successful) {
                            resolve(response.data.data)
                        } else {
                            reject('error')
                        }

                    })
                    .catch((e) => {
                        reject(e.response)
                    })
            })
    },
    downloadTemplates(downloadURL, selectedItems) {
        return new Promise(
            function (resolve, reject) {
                Skye.HttpClient({
                    url: downloadURL,
                    method: 'POST',
                    responseType: 'blob',
                    headers: {
                        Authorization: localStorage.getItem('token'),
                    },
                    data: {'templateIdList': selectedItems}
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch((e) => {
                        reject(e)
                    })
            })
    },

    async checkOverallHealth() {
        try {
            const response = await Skye.HttpClient.get(BACKEND_URL + Constants.getOverallHealth);
            return await response.data && response.data.overallHealth && response.data.overallHealth.toLowerCase() === 'ok' ? true : false;
        } catch (error) {
            return await false;
        }
    }
};

export default HelperServices;
